import React, { useState } from 'react';

import css from './Section.module.css';
import Icons from '../../../components/Icons/Icons';
import classNames from 'classnames';

function HowItWorks() {
  const [activeTab, setActiveTab] = useState('buyer');

  const buyerSections = [
    {
      icon: 'search',
      title: 'Browse & Compare',
      description:
        'Explore tiles, mats, racks, and accessories. Filter by style, condition, and seller rating.',
    },
    {
      icon: 'offer',
      title: 'Buy',
      description:
        'Check out instantly. Secure checkout keeps every purchase protected.',
    },
    {
      icon: 'securePayment',
      title: 'Track & Enjoy',
      description:
        'Get real-time updates from purchase to delivery, then get back to playing.',
    },
  ];

  const sellerSections = [
    {
      icon: 'list',
      title: 'Create a Profile',
      description:
        'A Secure Stripe Account so you can get paid fast, create a polished listing with photos and pricing.',
    },
    {
      icon: 'users',
      title: 'List in Minutes',
      description:
        'Create a listing wth photos, pricing and integrated shipping',
    },
    {
      icon: 'payment',
      title: 'Ship & Get Paid',
      description:
        'Ship with confidence and receive secure payouts after delivery confirmation.',
    },
  ];

  const sections = activeTab === 'buyer' ? buyerSections : sellerSections;

  return (
    <div className={css.howItWorkSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>HOW IT WORKS!</h2>
          <p>Get started in just a few steps, whether you’re buying or selling.</p>
          <div className={css.tabs}>
            <span
              className={classNames(css.tab, { [css.active]: activeTab === 'buyer' })}
              onClick={() => setActiveTab('buyer')}
            >
              For Buyers
            </span>
            <span
              className={classNames(css.tab, { [css.active]: activeTab === 'seller' })}
              onClick={() => setActiveTab('seller')}
            >
              For Sellers
            </span>
          </div>
        </div>
        <div className={css.moreInfoSec}>
          {sections.map((section, index) => (
            <div className={css.moreInfoBlock} key={index}>
              <span className={css.icon}>
                <Icons name={section.icon} />
              </span>
              <h4>{section.title}</h4>
              <p>{section.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
